export default __webpack_public_path__ + "static/media/login-bg.d4b7eba1.webp";